/* tslint:disable */
/* eslint-disable */
export enum WorkScreenslideLayoutEnum {
  Fullscreen = 'Fullscreen',
  SidebarLeft = 'Sidebar Left',
  SidebarRight = 'Sidebar Right',
  Header = 'Header',
  Footer = 'Footer',
  Grid = 'Grid'
}
